
import { atom } from '@zedux/react'

const editSettings = atom('editSettings', false);

export default editSettings;
